import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import RadioGroup from "Shared/RadioGroup";
import RadioInput from "Shared/RadioGroup/RadioInput";
import CalculatorRow from "src/components/CustomizePayment/CalculatorRow";
import { ApplicationStore } from "src/store";
import { patchPaymentsRequest } from "src/store/actions/payments";
import { getPaymentFrequencyOptionsArray } from "src/store/selectors/financeSettings";
import { getSelectedFrequency } from "src/store/selectors/vehicles";

interface Props {
    vin: string;
    paymentType: string;
}

const PaymentFrequency = ({
    uuid,
    vin,
    paymentType,
    frequencyOptions,
    frequency,
    patchFrequency,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const handlePaymentFrequencyChange = (name: string, value: string) => {
        patchFrequency(
            uuid,
            vin,
            {
                [paymentType]: {
                    frequency: value,
                },
            },
            "patch_payment_frequency"
        );
    };

    if (frequencyOptions.length < 2) {
        return null;
    }

    return (
        <CalculatorRow className="CalculatorRow__paymentType" title={t("CustomizePayment.PaymentFrequency.title")}>
            <RadioGroup onChange={handlePaymentFrequencyChange} name="paymentFrequency">
                {frequencyOptions.map(({ value, text }) => (
                    <RadioInput key={value} label={text} id={value} value={value} isDefault={frequency === value} />
                ))}
            </RadioGroup>
        </CalculatorRow>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin, paymentType }: Props) => ({
    uuid: state.deal.uuid!,
    frequencyOptions: getPaymentFrequencyOptionsArray(state, vin, paymentType),
    frequency: getSelectedFrequency(state, vin, paymentType),
});

const mapDispatchToProps = {
    patchFrequency: patchPaymentsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentFrequency);
